import { render, staticRenderFns } from "./MemberAreaSetup.vue?vue&type=template&id=49dcd042&scoped=true&"
import script from "./MemberAreaSetup.vue?vue&type=script&lang=js&"
export * from "./MemberAreaSetup.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaSetup.vue?vue&type=style&index=0&id=49dcd042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dcd042",
  null
  
)

export default component.exports